export const FILTER_ADDED = 'added';
export const FILTER_MASTER_CAMPAIGNS = 'masterCampaignIds';
export const FILTER_APPLICATIONS = 'applicationIds';

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_MASTER_CAMPAIGNS = 'masterCampaigns';
export const COLUMN_LAST_UPDATED_BY = 'updatedBy';
export const COLUMN_LAST_UPDATED_DATE = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'created';

export const ACTION_EDIT = 'Edit';
export const ACTION_DUPLICATE = 'Duplicate';
export const ACTION_DELETE = 'Delete';
